import { render, staticRenderFns } from "./SalesTeam.vue?vue&type=template&id=47a2f790"
import script from "./SalesTeam.vue?vue&type=script&lang=js"
export * from "./SalesTeam.vue?vue&type=script&lang=js"
import style0 from "./SalesTeam.vue?vue&type=style&index=0&id=47a2f790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports